import { render, staticRenderFns } from "./edit-userprofile-form.vue?vue&type=template&id=27575478&scoped=true&"
import script from "./edit-userprofile-form.vue?vue&type=script&lang=js&"
export * from "./edit-userprofile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27575478",
  null
  
)

export default component.exports